var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGridMenus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1223",
    "data-name": "Group 1223",
    transform: "translate(-1007 -549)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_266",
    "data-name": "Ellipse 266",
    transform: "translate(1007 549)",
    fill: "#36f",
    stroke: "#e6e6e6",
    strokeWidth: 1,
    opacity: 0.179
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.5,
    cy: 26,
    rx: 26.5,
    ry: 26,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.5,
    cy: 26,
    rx: 26,
    ry: 25.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "dataset_FILL0_wght400_GRAD0_opsz48",
    d: "M125.636,234.235h4.642v-4.642h-4.642Zm7.957,0h4.642v-4.642h-4.642Zm-7.957-7.957h4.642v-4.642h-4.642Zm7.957,0h4.642v-4.642h-4.642Zm-11.6,13.594A2.04,2.04,0,0,1,120,237.883V217.989A2.04,2.04,0,0,1,121.989,216h19.893a2.04,2.04,0,0,1,1.989,1.989v19.893a2.04,2.04,0,0,1-1.989,1.989Zm0-1.989h19.893V217.989H121.989Zm0-19.893v0Z",
    transform: "translate(902 347.639)",
    fill: "#36f",
    opacity: 0.75
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridMenus);
export default __webpack_public_path__ + "static/media/grid-menus.4d7ec13fc2088ac0a5753fb12110cfeb.svg";
export { ForwardRef as ReactComponent };